// extracted by mini-css-extract-plugin
export default {"error":"styles_error__jt4PO","success":"styles_success__ZUGZA"};